import React from 'react';
import cn from 'classnames';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { formSpacingFactor } from 'globals/units';

interface FsFormGridWrapperProps extends BoxProps {
  isBlock?: boolean;
}

export const FsFormGridWrapper = withStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    marginLeft: spacing(-formSpacingFactor),
    marginRight: spacing(-formSpacingFactor),
    marginBottom: spacing(formSpacingFactor * 2),
    '&.isBlock': {
      marginLeft: 0,
      marginRight: 0,
      display: 'block',
      width: '100%',
      '& > div': {
        marginLeft: 0,
        marginRight: 0,
        marginBottom: spacing(formSpacingFactor * 2),
      },
    },
  },
}))(({ isBlock, ...otherProps }: FsFormGridWrapperProps) => (
  <Box {...otherProps} className={cn({ isBlock })} />
));

export default FsFormGridWrapper;
